module.exports = "https://health.dajiuxing.com.cn/img/views/aboutUs/img/1.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2FaboutUs%2Fimg%2F1.jpg
// module id = Yz8q
// module chunks = 93